import { useEffect } from "react";

export function useTawk(propertyId: string, widgetId: string) {

    useEffect(() => {
        // Initialize Tawk.to widget
        const tawkWindow = window as any;
        tawkWindow.Tawk_API = tawkWindow.Tawk_API || {};
        tawkWindow.Tawk_LoadStart = new Date();

        // Create and append the Tawk.to script
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
        script.type = "text/javascript";

        document.body.appendChild(script);

        return () => {
            // Cleanup on unmount
            if (tawkWindow.Tawk) {
                tawkWindow.Tawk.hideWidget();
            }
        };
    }, [propertyId, widgetId]);
}
